// js
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import Button from '../common/Button';
// css
import '../../styles/components/sources/DefaultLogSizeSelectorWarningModal.scss';


const DefaultLogSizeSelectorWarningModal = ({ open, onSubmit, onDismiss }) => (

  <Modal
    className='default-log-size-selector-warning-modal'
    open={open}
    onDismiss={onDismiss}
  >
    <h3>Warning</h3>
    <p>Changing the default log size will reset all of the estimated log size inputs for all your configured items, which may result in data loss. Are you sure you want to proceed?</p>
    <div className='default-log-size-selector-warning-modal__buttons'>
      <Button
        onClick={onDismiss}
        label='Cancel'
      />
      <Button
        primary
        onClick={onSubmit}
        onEnterKey={onSubmit}
        label='Proceed'
      />
    </div>
  </Modal>
);

DefaultLogSizeSelectorWarningModal.defaultProps = {
  open: false
};

DefaultLogSizeSelectorWarningModal.propTypes = {
  open: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default DefaultLogSizeSelectorWarningModal;



// WEBPACK FOOTER //
// ./src/components/sources/DefaultLogSizeSelectorWarningModal.js